import { render, staticRenderFns } from "./storeTop.vue?vue&type=template&id=3b9bc748&"
import script from "./storeTop.vue?vue&type=script&lang=js&"
export * from "./storeTop.vue?vue&type=script&lang=js&"
import style0 from "./storeTop.vue?vue&type=style&index=0&id=3b9bc748&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports